import React from 'react';
import { Outlet } from 'react-router-dom';
import { AdaptiveNavigation } from './AdaptiveNavigation';
import { AppTopBar } from './AppTopBar';

export function AppShell() {
  return (
    <div className="app-shell" data-testid="app-shell">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <AdaptiveNavigation />
      <div className="app-main-wrap">
        <AppTopBar />
        <main id="main-content" className="app-main" role="main" tabIndex={-1}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
